// Four-digit years everywhere (T41074, T41069). Two-digit input is still accepted when typed.
export const LOCAL_DATE_FORMATS = {
    parse: {
        dateInput: ['DD/MM/YYYY', 'DD/MM/YY']
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};

export function compareDate(date1, date2) {
    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);

    if (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    ) {
        return 0;
    }
    return date1 > date2 ? 1 : -1;
}
